import { FC } from 'react';

import { TColorProp } from 'styled-components';

import { AlertInfoContainer } from './styles';
import { Typography } from '../Typography';

interface IAlertInfoProps {
  readonly width?: string | number;
  readonly title?: string;
  readonly color?: TColorProp;
  readonly textColor?: TColorProp;
  readonly info?: string | JSX.Element;
  readonly center?: boolean;
  readonly textAlign?: string;
}
export const AlertInfo: FC<IAlertInfoProps> = ({
  width = '100%',
  title = 'Atenção',
  color = 'orange.500',
  textAlign = 'left',
  textColor = 'neutral.0',
  info,
}) => {
  return (
    <AlertInfoContainer
      textAlign={textAlign}
      width={typeof width === 'number' ? `${width}px` : width}
      color={color}
    >
      <div id="border-left" />

      {title && (
        <Typography.Paragraph
          size="medium"
          color={textColor}
          style={{ fontWeight: 'bold' }}
        >
          {title}
        </Typography.Paragraph>
      )}

      {typeof info === 'string' ? (
        <Typography.Paragraph size="small" color={textColor}>
          {info}
        </Typography.Paragraph>
      ) : (
        <>{info}</>
      )}
    </AlertInfoContainer>
  );
};
